import { render, staticRenderFns } from "./SendMessageToCourse.vue?vue&type=template&id=719d6556"
import script from "./SendMessageToCourse.vue?vue&type=script&lang=ts"
export * from "./SendMessageToCourse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports